import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import _ from "lodash";
import LabDetails from "../LabDetails/LabDetails";
import SampleDetails from "../SampleDetails/SampleDetails";
import LoaderComponent from "../../../components/Loader/LoaderComponent";
import "./LabSampleSections.css";
import {
  getActionsButton,
  getSampleDocRequirements,
  getSpecificSampleDetail,
  UpdateLabSamples,
} from "../../../services/LabService";
import { UploadFile } from "../../../services/FortificationService";
import ActionsModal from "../ActionButtons/ActionsModal";
import { useDispatch, useSelector } from "react-redux";
import "../../../App.css";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MAIN_BLUE } from "../../../color";
import moment from 'moment'
import KeycloakService from "../../../services/KeycloakService";
import useTranslatewrapper from "../../../components/useTranslateWrapper";
function RjsfSampleForm() {
  const navigate = useNavigate();
  const {translate} = useTranslatewrapper();
  const userDetails = KeycloakService.getUserDetail()
  const isMonitor = userDetails?.isMonitor;

  const [batchId, setBatchId] = useState("");
  const [sampleTableData, setSampleTableData] = useState();
  const [lastActionDate, setLastActionDate] = useState();
  const [lastActionDateReject, setLastActionDateReject] = useState();

  const [sampleData, setSampleData] = useState({});
  const [autoPopulatedData, setAutoPopulatedData] = useState();
  const [createFileUploadFields, setCreateFileUploadFields] = React.useState(
    []
  );
  const [sourceCategoryData, setSourceCategoryData] = React.useState([]);
  const [loader, setLoader] = useState(false);
  const [stateChange, setStateChange] = useState(false);
  const [testDone, setTestDone] = useState(false);
  const [fileData, setFileData] = React.useState([]);
  const [fileBody, setFileBody] = React.useState([]);
  const [testDate, setTestDate] = useState();
  const [buttons, setButtons] = useState(null);
  const [deleteFiles, setDeleteFiles] = React.useState([]);
  const [removedNames, setRemovedNames] = useState([]);
  const [showButton, setShowButton] = useState(false);
  const [currentCategoryId, setCurrentCategoryId] = useState(2);
  const [requestBody, setRequestBody] = useState({});//
  const [inputData, setInputData] = useState({
    testDate: moment().local().format('YYYY-MM-DD'),
  });

  const [formReceivedDate, setFormReceivedDate] = useState(null);

  const searchParams = new URLSearchParams(window.location.search);
  const didRedirectToHere = searchParams.get('redirected')

  const setDate = (value) => {
    setFormReceivedDate(value);
    setLastActionDateReject(value);
  };
  const setData = (value) => {
    setInputData(value);
  };
  const setChange = (value) => {
    setStateChange(value);
  };

  const getSampleId = useParams();
  const location = useLocation();

  const setTableData = (data) => {
    setSampleTableData(data);
  };

  useEffect(() => {
    setLoader(true);
    editFetchData();
  }, [location.pathname]);

  const editFetchData = async () => {
    const data = await getSpecificSampleDetail(getSampleId?.id);
    setShowButton(false);
    if (data?.data) {
      setCurrentCategoryId(data?.data?.categoryId);
      setLastActionDate(data?.data?.sampleSentDate?.slice(0, 10));

      setLastActionDateReject(data?.data?.receivedDate?.slice(0, 10));
      const sampleSentDate = data?.data.sampleSentDate?.slice(0, 10);
      var labDetailsObj = {};
      labDetailsObj["BatchNo"] = data?.data.batchNo ?? data?.data?.lotNo;
      labDetailsObj["SampleSentDate"] = sampleSentDate;

      setAutoPopulatedData(labDetailsObj);
      setSampleTableData(data?.data.labTests);
      setSampleData(data?.data);
      setTestDate(data?.data.testDate?.slice(0, 10));
      setBatchId(data?.data.batchId);
      const CategoryDocsArray = await getSampleDocRequirements(
        data?.data?.categoryId
      );
      setSourceCategoryData(CategoryDocsArray.data);
      setFileBody(() => data?.data?.sampleTestDocuments);
      setCreateFileUploadFields(() => [
        ...prepareSourceCategoryExtraDocs(
          data?.data?.sampleTestDocuments,
          CategoryDocsArray?.data.categoryDocumentRequirements.map((item) => {
            return {
              ...item.docType,
              id: item.id,
              isMandatory: item.isMandatory,
            };
          })
        ),
      ]);
      setActionButtons(
        data?.data.batchId ? data?.data.batchId : data?.data?.lotId,
        data?.data?.batchId ? "batch" : "lot",
        false,
        data?.data?.inspectionId ? data?.data?.state?.name : ""
      );
      setLoader(false);
    }
  };

  const removeDeletedFiles = () => {

    // let tempFileBody = [...fileBody];
    let tempFileBody = [
      ...fileBody.filter((obj) => !(obj.name == "" && obj.categoryDocId == "")),
    ];
    removedNames.forEach((removedName) => {
      const deleteFileIndexesArray = fileBody.filter(
        (file) => !file?.id && file.name === removedName
      );
      deleteFileIndexesArray.forEach((deleteItem) => {
        const deleteFileIndex = fileBody.findIndex(
          (file) => file.name === deleteItem.name
        );
        if (deleteFileIndex !== -1) {
          tempFileBody.splice(deleteFileIndex, 1);
        }
      });
    });

    // deleteFiles.forEach((deleteItem) => {
    //   const deleteFileIndex = fileBody.findIndex(
    //     (file) =>
    //       file.path === deleteItem.path &&
    //       file.name === deleteItem.name &&
    //       file.categoryDocId === deleteItem.categoryDocId
    //   );
    //   if (deleteFileIndex !== -1) {

    //     tempFileBody.splice(deleteFileIndex, 1);
    //
    //   }
    // });

    // changed the delete file logic to fix bug of not removing the last file
    tempFileBody = fileBody.filter((data) => !deleteFiles?.includes(data));
    return tempFileBody;
  };

  const addPath = async (file, idx, callType) => {
    const fileUploaded = await UploadFile({
      file: file,
    });
  };

  useEffect(() => {
    sendFormData();
  }, [fileBody, inputData, sampleTableData, deleteFiles]);

  const sendFormData = () => {
    const data = sampleTableData?.map((item) => {
      let maxValue = null
      let minValue = null;
      let defaultPresent = null;
      // console.log(item.selectionList)
      if (item.selectionList) {
        for (let listitem of item.selectionList) {
          if (listitem.name == item.reference) {
            maxValue = listitem?.maxValue
            minValue = listitem?.minValue
            defaultPresent = listitem?.defaultPresent
          }
        }
      }
      // console.log(maxValue, "max")
      // console.log(minValue, "min")
      // console.log(item.name, "refmethod")
      return {
        labTestReferenceMethodId: item.labTestReferenceMethodId,
        testName: item.reference ? item.reference : item.name,
        defaultPresent: item.defaultPresent,
        value: item?.result,
        testDate: "2023-02-16",
        performedBy: "",
        labSampleId: getSampleId?.id,
        requestStateId: 0,
        uom: item.uom,
        testMethodFollowed: item?.testMethodFollowed,
        maxValue: maxValue,
        minValue: minValue,
        defaultPresent: defaultPresent,
        referenceMethod: item.name,


        //maxValue
        //minValue
        //referenceMethod - item.name
      };
    });
    const LabData = {
      batchId: sampleData?.batchId,
      lotId: sampleData?.lotId,
      testDate: inputData.testDate,
      sampleSentDate: sampleData.sampleSentDate,
      receivedDate: sampleData.receivedDate || formReceivedDate,
      performedBy: inputData.performedBy,
      labId: sessionStorage.getItem("labId"),
      requestStatusId: 0,
      categoryId: currentCategoryId,
      sampleProperties: sampleData.sampleProperties,
      labTests: data,
      sampleTestDocuments: removeDeletedFiles(),
      stateId: 1,
      testMethodFollowed: sampleData?.testMethodFollowed,
    };
    LabData[sampleData.batchNo ? "batchNo" : "lotNo"] =
      sampleData?.batchNo ?? sampleData?.lotNo;

    // console.log("setting lab data in rjsf sample form")
    setRequestBody(LabData);
  };

  const dispatch = useDispatch();

  const filterDataRedux = useSelector((state) => state.filterData);

  const setFilters = (filterData) => {
    var json = filterDataRedux.searchCriteriaList;
    var json1 = structuredClone(json);

    json1[0].value = "";
    json1[1].value = "";
    json1[2].value = "";
    dispatch({
      type: "UPDATE_FILTER",
      data: json1,
    });
  };

  const prepareSourceCategoryExtraDocs = (extraDocs, requiredDocs) => {
    if (
      (extraDocs && extraDocs.length > 0) ||
      (requiredDocs && requiredDocs.length > 0)
    ) {
      const docCategories = _.groupBy(
        extraDocs,
        (data) => data?.name || data.categoryDoc?.docType?.name
      );
      const formattedExtras = [];
      Object.entries(docCategories).forEach((item) => {
        const formattedObject = {
          paths: item[1],
        };

        if (item[1][0]?.categoryDoc) {
          formattedObject.id = item[1][0]?.labSampleId;
          formattedObject.name = item[0];

          formattedObject.paths = item[1].map((docItem) => {
            return { ...docItem, categoryDocId: docItem.labSampleId };
          });
        } else {
          formattedObject.name = item[0];
        }
        formattedExtras.push(formattedObject);
      });
      return customSortDocuments(
        addRequiredDocs(formattedExtras, requiredDocs)
      );
    }
    return [];
  };

  const addRequiredDocs = (currentDocs, requiredDocs) => {
    if (currentDocs.length) {
      requiredDocs.forEach((doc) => {
        if (currentDocs.findIndex((elem) => elem.name === doc.name) === -1) {
          currentDocs.push({ ...doc, categoryId: doc.id, paths: [] });
        }
      });
    }
    else {
      requiredDocs.forEach((doc) => {
        currentDocs.push({ ...doc, categoryId: doc.id, paths: [] });
      });
    }
    return currentDocs;
  };

  const customSortDocuments = (initialArray) => {
    return initialArray.sort((a, b) => {
      if (a.id && !b.id) {
        return -1; // a comes first
      } else if (!a.id && b.id) {
        return 1; // b comes first
      } else {
        return 0; // no change in order
      }
    });
  };

  //   useEffect(() => {

  //     // if(buttons!=null){
  //       // (buttons!=null && buttons?.length > 0) ? setTestDone(false) : setTestDone(true);
  // buttons?.length===0 && setTestDone(true)
  //     // }
  //   }, [buttons]);

  const setActionButtons = async (batchId, type, shouldNavigate, stateName, isInspectionSample) => {

    const actionButtonsData = await getActionsButton(
      currentCategoryId,
      batchId,
      type,
      stateName
    );
    if (
      shouldNavigate &&
      (!actionButtonsData?.data || actionButtonsData?.data?.length < 1)
    ) {
      navigate(localStorage.getItem("current-page-path"));
    }
    actionButtonsData && setButtons(actionButtonsData?.data);
    actionButtonsData &&
      actionButtonsData?.data?.length === 0 &&
      setTestDone(true);

    if (
      actionButtonsData?.data[0]?.name !== "batchSampleInLab" &&
      actionButtonsData?.data[0]?.name !== "lotSampleInLab"
    ) {
      setStateChange(true);
    } else {
      setStateChange(false);
    }
  };
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const pathName = location.pathname.split("/").filter((x) => x);
  const showAccordion = () => {
    if (
      (!didRedirectToHere &&
      buttons &&
      !buttons[0]?.name.includes("SampleInLab") &&
      !sampleData?.state?.name.toLowerCase().includes("rejected")
      ) || (
        didRedirectToHere && 
        sampleData?.state?.name.toLowerCase().includes("done")
      )
    ) {
      return true;
    } else return false;
  };
  return (
    <div className="main-content-overlay">
      <Typography variant="h6" sx={{ color: MAIN_BLUE, mx: 1 }}>
        {`${capitalize(translate(pathName[0].replace('miller','Miller(FR)')))} ${translate('sampleDetails')}`}
      </Typography>
      <Box className="main-content-div">
        <Button
          onClick={(e) => {
            navigate(-1);
            // setFilters();
          }}
          hidden={didRedirectToHere}
          sx={{ margin: 1 }}
        >
          <ArrowBackIcon />
          <Typography
            sx={{ fontSize: "13px", textDecorationLine: "underline" }}
          >
            {translate("Back to home")}
          </Typography>
        </Button>

        {loader ? (
          <LoaderComponent />
        ) : (
          <Accordion defaultExpanded={true}>
            <AccordionSummary
              expandIcon={
                <ExpandMoreIcon
                  sx={{ color: "#fff", background: "#0075FF", height: "35px" }}
                />
              }
              sx={{ color: "0075FF" }}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Box className="formTitle">
                <Typography className="formBox-text">{translate('sampleDetails')}</Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <LabDetails autoPolulatedData={autoPopulatedData} />
            </AccordionDetails>
          </Accordion>
        )}

        {loader ? (
          <LoaderComponent />
        ) : (
          showAccordion() &&
          (
            <Accordion defaultExpanded={false}>
              <AccordionSummary
                expandIcon={
                  <ExpandMoreIcon
                    sx={{
                      color: "#fff",
                      background: "#0075FF",
                      height: "35px",
                    }}
                  />
                }
                sx={{ color: "0075FF" }}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Box className="formTitle">
                  {" "}
                  <Typography className="formBox-text">
                    {sampleData.state.name === 'done' ? translate('viewLabTestDetails') : translate('addLabTestDetails')}
                  </Typography>
                </Box>
              </AccordionSummary>
              <AccordionDetails>
                <SampleDetails
                  testDone={testDone}
                  isMonitor={isMonitor}
                  sampleData={sampleData}
                  setSampleTestData={setTableData}
                  addPath={addPath}
                  createFileUploadFields={createFileUploadFields}
                  getFileData={setFileBody}
                  handleFileDelete={setDeleteFiles}
                  showButton={showButton}
                  setShowButton={setShowButton}
                  sampleId={sampleData?.id}
                  setRemovedNames={setRemovedNames}
                  currentCategoryId={currentCategoryId}
                  fileUploadData={removeDeletedFiles()}
                  sourceCategoryData={sourceCategoryData}
                  sampleTableData={sampleTableData}
                  setData={setData}
                  inputData={inputData}
                />
              </AccordionDetails>
            </Accordion>
          )
        )}

        {loader ? (
          <LoaderComponent />
        ) : (
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            {
              <ActionsModal
                sampleData={sampleData}
                buttons={buttons}
                setStateChange={setChange}
                testDate={testDate}
                currentCategoryId={currentCategoryId}
                type={sampleData?.batchNo ? "batch" : "lot"}
                sampleId={sampleData?.id}
                setActionButtons={setActionButtons}
                showButton={showButton}
                requestBody={requestBody}
                sampleTableData={sampleTableData}
                sourceCategoryData={sourceCategoryData}
                setDate={setDate}
                lastActionDate={lastActionDate}
                lastActionDateReject={lastActionDateReject}
              />
            }
          </Box>
        )}
      </Box>
    </div>
  );
}

export default RjsfSampleForm;
